import Vue from 'vue'
import Router from 'vue-router'

const Home = (resolve) => {
	import('components/home/home').then((module)=>{
		resolve(module)
	})
}
const Products = (resolve) => {
	import('components/products/products').then((module)=>{
		resolve(module)
	})
}
const About = (resolve) => {
	import('components/about/about').then((module)=>{
		resolve(module)
	})
}
const Contact = (resolve) => {
	import('components/contact/contact').then((module)=>{
		resolve(module)
	})
}
const Certificate = (resolve) => {
	import('components/certificate/certificate').then((module)=>{
		resolve(module)
	})
}
const ProductDetail = (resolve) => {
	import('components/product-detail/product-detail').then((module)=>{
		resolve(module)
	})
}
const Source = (resolve) => {
	import('components/source-download/source-download').then((module)=>{
		resolve(module)
	})
}
const SourceDetail = (resolve) => {
	import('components/source-download/source-download-detail').then((module)=>{
		resolve(module)
	})
}

Vue.use(Router)

export default new Router({
	routes:[{
		path:"/",
		redirect:"/home"
	},
	{
		path:"/home",
		component:Home
	},
	{
		path:"/products",
		component:Products,
		children:[
			{
				path:":id",
				component:ProductDetail
			}
		]
	},
	{
		path:"/about",
		component:About
	},
	{
		path:"/contact",
		component:Contact
	},
	{
		path:"/certificate",
		component:Certificate
	},{
		path:'/source',
		component:Source,
		children:[
			{
				path:":id",
				component:SourceDetail
			}
		]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js